// Zentrale Anzeige-/Anrede-Logik für Eigentümer — Firma vs. Person.
// Das Kennzeichen ist die Anrede „Firma" (Formular setzt sie, Firmenname wird dann Pflicht,
// Vor-/Nachname optional = Ansprechpartner). Für ältere Datensätze greift ein Fallback:
// nur Firmenname ohne Personennamen → ebenfalls Firma.

import { briefAnrede as briefAnredePerson } from '../dokumente/briefDaten';

export interface EigentuemerNameFelder {
  anrede?: string | null;
  vorname?: string | null;
  nachname?: string | null;
  firma_name?: string | null;
}

// Name des Ansprechpartners (Person), leer wenn keiner hinterlegt ist.
export function ansprechpartnerName(e: EigentuemerNameFelder): string {
  return `${e.vorname ?? ''} ${e.nachname ?? ''}`.replace(/\s+/g, ' ').trim();
}

// Ist der Eigentümer eine Firma? Anrede „Firma" ODER (Firmenname vorhanden UND kein Personenname).
export function istFirma(e: EigentuemerNameFelder): boolean {
  if (e.anrede === 'Firma') return true;
  return !!e.firma_name?.trim() && ansprechpartnerName(e) === '';
}

// Haupt-Anzeigename: bei Firma der Firmenname, sonst der Personenname. Robuster Fallback,
// damit nie ein leerer Name entsteht.
export function eigentuemerAnzeigename(e: EigentuemerNameFelder): string {
  const firma = e.firma_name?.trim() || '';
  const person = ansprechpartnerName(e);
  if (istFirma(e)) return firma || person || '—';
  return person || firma || '—';
}

// Ansprechpartner-Zeile, die neben dem Firmennamen angezeigt wird (leer, wenn keine Firma
// oder kein Ansprechpartner) — verhindert die Dopplung „Firmenname == Personenname".
export function ansprechpartnerZusatz(e: EigentuemerNameFelder): string {
  if (!istFirma(e)) return '';
  const person = ansprechpartnerName(e);
  if (!person || person === (e.firma_name?.trim() || '')) return '';
  return person;
}

// Brief-Anrede: persönliche Anrede bei Herr/Frau + Nachname, sonst „Sehr geehrte Damen und Herren,".
// (Firmen haben nur EIN Anrede-Feld = „Firma", daher keine persönliche Anrede des Ansprechpartners.)
// Personen: gemeinsame Regel aus briefDaten (auch Eheleute, Divers und Altanreden, #586 Etappe 3).
export function briefAnrede(e: EigentuemerNameFelder): string {
  if (istFirma(e)) return 'Sehr geehrte Damen und Herren,';
  return briefAnredePerson(e);
}
